import { render, staticRenderFns } from "./ProposalSummaryEdit.vue?vue&type=template&id=7f2978f7&"
import script from "./ProposalSummaryEdit.vue?vue&type=script&lang=js&"
export * from "./ProposalSummaryEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProposalSummaryEdit.vue?vue&type=style&index=0&id=7f2978f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports